import { SxProps } from "@mui/material";

const root: SxProps = {};

const colorsContainer = (
  isEasyEditable: boolean,
  isOpen: boolean
): SxProps => ({
  height: "28px",
  width: isOpen ? "300px" : "28px",
  display: { xs: "none", md: "inline-flex" },
  position: "absolute",
  right: "12px",
  bottom: "12px",
  zIndex: 3,
  overflow: "hidden",
  padding: "7px",
  borderRadius: "6px",
  opacity: isEasyEditable ? 0 : 1,
  transition: "0.3s",
  boxShadow: "0px 0px 7px 0px #00000038",
  gap: "6px",
  alignItems: "center",
});

const overlay = (isOpen: boolean): SxProps => ({
  top: "0px",
  bottom: "0px",
  left: "0px",
  right: "0px",
  zIndex: 2,
  position: "absolute",
  display: isOpen ? "block" : "none",
  cursor: "pointer",
});

const colorItem = (color: string): SxProps => ({
  height: "20px",
  width: "20px",
  backgroundColor: color,
  ":hover": {
    backgroundColor: color,
  },
});

export { colorItem, colorsContainer, overlay, root };
